export default __webpack_public_path__ + "static/media/element_11.a8519a0d.jpg";